import { Injectable } from '@angular/core';
import { SetupWidgetInfo } from '@core/models';
import { SetupDashbordStore } from '@core/models/widgets/setup-dashboard-store.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SetupDashbordStoreService {

  private readonly _initialStoreData: SetupDashbordStore = {
    widgetInfo: null,
    sysText: null,
  };

  private readonly templateNames = {
    setupDashboard: "setupDashboard",
    emailTemplatesWidget: "emailTemplatesWidget",
    workSchedulesWidget: "workSchedulesWidget",
    actionItemsTemplatesWidget: "actionItemsTemplatesWidget",
    leaveReasonsWidget: "leaveReasonsWidget",
  };

  private setupStore: BehaviorSubject<SetupDashbordStore>;
  private store$: Observable<SetupDashbordStore>;

  constructor() {
    this.setupStore = new BehaviorSubject(this._initialStoreData);
    this.store$ = this.setupStore.asObservable();
  }

  public get templates() {
    return this.templateNames;
  }

  public get store() {
    return this.setupStore.value;
  }

  public get storeObs$() {
    return this.store$;
  }

  public get widgetInfo$(): Observable<SetupWidgetInfo> {
    return this.store$.pipe(pluck('widgetInfo'));
  }

  public get widgetInfo() {
    return this.store.widgetInfo;
  }

  public get sysText() {
    return this.store.sysText;
  }

  public set sysText(sysText: any) {
    const store = { ...this.store, sysText };
    this.setupStore.next(store);
  }

  public set widgetInfo(widgetInfo: SetupWidgetInfo) {
    const store = { ...this.store, widgetInfo };
    this.setupStore.next(store);
  }

  public unloadStore() {
    const store: SetupDashbordStore = {
      widgetInfo: null,
      sysText: null
    }
    this.setupStore.next(store)
  }
}
